// file为图片文件 size为压缩比例
export async function compressPic(file, size) {
	let reader = new FileReader();
	reader.readAsDataURL(file);
	let nfile = '';
	let promise = new Promise((reslove) => {
		reader.onload = function(e) {
			let image = new Image();
			image.src = e.srcElement.result;
			image.onload = function() {
				// 画canvas
				let canvas = document.createElement('canvas');
				let ctx = canvas.getContext('2d');
				let width = image.width;
				let height = image.height;
				canvas.width = width;
				canvas.height = height;
				// 铺底色
				ctx.fillStyle = '#fff';
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(image, 0, 0, width, height);
				// 图片压缩并导出
				let ndata = canvas.toDataURL('image/jpeg', size);
				// base64转file格式
				let arr = ndata.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				nfile = new File([u8arr], file.name, {
					type: mime
				});
				reslove();
			};
		};
	});
	await promise;
	return nfile;
}



// WEBPACK FOOTER //
// ./src/utils/compressPic.js